import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, watch } from 'vue';
import { RoleId } from '@/lib/enum';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import CompanyUserForm from '@/views/pages/companyUsers/CompanyUserForm.vue';
import { CompanyUserFormData, useUserComposable } from '@/composables/useUser';
import {
  Department,
  DepartmentTreeNode,
} from '@/interfaces/model/general/department';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { commitAddNotification } from '@/store/main/mutations';
import { store } from '@/store/index';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInviteDialog',
  props: {
    value: { type: Boolean },
    selectableDepartments: null,
    departmentTree: null
  },
  emits: ["input", "invited"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'invited'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  selectableDepartments: Department[];
  departmentTree: DepartmentTreeNode[];
};

const m = defineMessages({
  inviteUser: 'ユーザーを招待',
  alreadyExistsEmail: 'このメールアドレスは既に登録されています。',
});

const { createCompanyUser } = useUserComposable();




const localValue = ref(props.value);

watch(
  () => props.value,
  (newValue) => {
    localValue.value = newValue;
  }
);

const isValidForm = ref(false);
const isLoading = ref(false);
const formRef = ref();
const userForm = reactive<CompanyUserFormData>({
  firstName: '',
  lastName: '',
  middleName: '',
  email: '',
  departments: [],
  position: '',
  isSubscribe: true,
  phone: '',
  roleId: RoleId.USER_ADMIN.value,
});

const resetForm = () => {
  userForm.firstName = '';
  userForm.lastName = '';
  userForm.middleName = '';
  userForm.email = '';
  userForm.departments = [];
  userForm.position = '';
  userForm.phone = '';
  userForm.roleId = RoleId.USER_ADMIN.value;
};

const closeDialog = () => {
  if (isLoading.value) {
    return;
  }
  resetForm();
  formRef.value.resetValidation();
  localValue.value = false;
  emits('input', false);
};

const handleInviteClick = async () => {
  formRef.value.validate();
  if (!isValidForm.value) {
    return;
  }
  isLoading.value = true;
  try {
    await createCompanyUser(userForm);
    isLoading.value = false;
    closeDialog();
    emits('invited');
  } catch (e) {
    isLoading.value = false;
    commitAddNotification(store, {
      messageKey: m.alreadyExistsEmail,
      color: 'error',
    });
  }
};

const handleCancelClick = () => {
  closeDialog();
};

const updateUserForm = (updatedForm: CompanyUserFormData) => {
  Object.assign(userForm, updatedForm);
};

return { __sfc: true,m, createCompanyUser, props, emits, localValue, isValidForm, isLoading, formRef, userForm, resetForm, closeDialog, handleInviteClick, handleCancelClick, updateUserForm, BaseFormCard, CompanyUserForm, sharedMessages }
}

})